/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const personDataSchema = z.object({
	id: z.string(),
	name: z.string().nullable(),
	summary: z.string().nullable(),
	emails: z.array(z.object({ value: z.string(), source_candidate_id: z.string().nullable(), added_at: z.string() })),
	phones: z.array(z.object({ value: z.string(), source_candidate_id: z.string().nullable(), added_at: z.string() })),
	skills: z.array(
		z.object({
			escoSkillId: z.string(),
			conceptUri: z.string(),
			label: z.string(),
			sources: z.array(z.object({ candidateId: z.string(), questionId: z.string(), optionId: z.string() })),
		}),
	),
	candidacies: z.array(
		z.object({
			id: z.string(),
			campaign: z.object({ id: z.string(), title: z.string() }),
			pipelineStageId: z.string().nullable(),
			pipelineStageType: z.string().nullable(),
			createdAt: z.iso.datetime().nullable(),
			poolConsentGivenAt: z.iso.datetime().nullable(),
			lastActivityLabel: z.union([
				z.literal('messaged'),
				z.literal('stage_moved'),
				z.literal('applied'),
				z.literal('interview'),
			]).nullable(),
			lastActivityAt: z.iso.datetime().nullable(),
			lastActivityActorType: z.union([z.literal('recruiter'), z.literal('candidate'), z.literal('system')])
				.nullable(),
			lastActivityActorName: z.string().nullable(),
		}),
	),
	previousNames: z.array(
		z.object({ value: z.string(), source_candidate_id: z.string().nullable(), replaced_at: z.string() }),
	).default([]),
})

export type PersonDataSchema = z.infer<typeof personDataSchema>
